// extracted by mini-css-extract-plugin
export default {"search-recommended-card":"BKno4J","search-recommended-card__Wrapper":"Mcz6ga"};